import { Stack } from '@mui/material';

import { PresentationTemplateStageEditorHeader } from './PresentationTemplateStageEditor.header';
import { PresentationTemplateStageEditorMain } from './PresentationTemplateStageEditor.main';
import { PresentationTemplateStageEditorSidebar } from './PresentationTemplateStageEditor.sidebar';

export function PresentationTemplateStageEditor() {
  return (
    <Stack direction="column" height="100%" width="100%" overflow="hidden">
      <PresentationTemplateStageEditorHeader />
      <Stack direction="row" flex="1 1 auto" minHeight={0}>
        <PresentationTemplateStageEditorSidebar />
        <PresentationTemplateStageEditorMain />
      </Stack>
    </Stack>
  );
}
